export function uuid(): string {
  if (
    typeof window.crypto !== "undefined" &&
    window.crypto.subtle != undefined
  ) {
    return window.crypto.randomUUID();
  }
  let d = new Date().getTime();
  const s = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  return s.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function guid(): string {
  return uuid().replace(/-/g, "");
}

export function formatDateTime(s: Date | string | number | null): string {
  let date = new Date();
  if (s instanceof Date) {
    date = s;
  } else if (typeof s === "string") {
    date = new Date(s.replace(/-/g, "/"));
  } else if (typeof s === "number") {
    date = new Date(s);
  }
  const hour = date.getHours();
  const minute = date.getMinutes();
  return `${hour < 10 ? "0" + hour : hour}:${minute < 10 ? "0" + minute : minute}`;
}

export function getURL(name: string, url: string): string {
  const urls: string[] | null = url.match(
    /([^?#]+)?(\?[^#]+)?(#[^?]+)?(\?[\w\W]+)?/,
  );
  if (!urls) {
    return "";
  }
  const searchURL: string = urls[2] || "";
  const re = new RegExp("(^|[&?])" + name + "=([^&]*)(&|$)", "i");
  const parameter = searchURL.match(re);
  if (parameter !== null) {
    return parameter[2];
  } else {
    return "";
  }
}

export function getRandomInRange(min: number, max: number): number {
  // 生成一个在 [min, max) 范围内的随机数
  const randomNum = Math.random() * (max - min) + min;
  // 保留一位小数
  return Math.round(randomNum * 10) / 10;
}

export function truncateString(str: string, maxLength: number): string {
  let realLength = 0;
  let result = "";

  for (let i = 0; i < str.length; i++) {
    const char = str.charAt(i);
    const charLength = encodeURIComponent(char).length > 2 ? 2 : 1;
    realLength += charLength;

    if (realLength > maxLength) {
      break;
    }

    result += char;
  }

  return realLength <= maxLength ? result : result + "...";
}

export function getSearchParams(url: string): { [key: string]: string } | null {
  const urls: string[] | null = url.match(
    /([^?#]+)?(\?[^#]+)?(#[^?]+)?(\?[\w\W]+)?/,
  );
  if (!urls || !urls[2]) {
    return null;
  }
  const searchURL: string = urls[2].replace(/^[?]/, "");
  const json: { [key: string]: string } = {};
  const searchParams = searchURL.split("&");
  searchParams.forEach((item: string) => {
    const info = item.split("=");
    json[info[0]] = info[1] || "";
  });
  return json;
}

export function addHttps(s: string): string {
  const url = s ?? "";
  return url.replace(/(https?:)?\/\//, "https://");
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function isArray(value: unknown): value is unknown[] {
  return Array.isArray(value);
}

export function isEqual<T>(a: T, b: T): boolean {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b || a === null || b === null) {
    return false;
  }

  if (isArray(a) && isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }

  if (isObject(a) && isObject(b)) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) {
      return false;
    }
    for (const key of keysA) {
      if (!(key in b)) {
        return false;
      }
      if (!isEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }

  return false;
}
